import { render, staticRenderFns } from "./Dialog_ChooseLesson.vue?vue&type=template&id=5551e758&scoped=true&"
import script from "./Dialog_ChooseLesson.vue?vue&type=script&lang=js&"
export * from "./Dialog_ChooseLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5551e758",
  null
  
)

export default component.exports